import React, { useState } from 'react';
import { useSubscription } from '../contexts/SubscriptionContext';

const Paywall = ({ onClose }) => {
    const { packages, purchasePackage, restorePurchases, isPro } = useSubscription();
    const [loading, setLoading] = useState(false);
    const [errorV, setError] = useState(null);

    const handlePurchase = async (pack) => {
        setLoading(true);
        setError(null);
        try {
            const success = await purchasePackage(pack);
            if (success) {
                onClose(); // Close paywall on success
            }
        } catch (err) {
            setError(err.message || 'Purchase failed');
        } finally {
            setLoading(false);
        }
    };

    const handleRestore = async () => {
        setLoading(true);
        setError(null);
        try {
            await restorePurchases();
            // If restored, check if pro is active
            if (isPro) {
                onClose();
            } else {
                setError('No active subscription found to restore.');
            }

        } catch (err) {
            setError(err.message || 'Restore failed');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.85)',
            zIndex: 2000,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            color: 'white',
            padding: '20px',
        }}>
            <div style={{
                backgroundColor: '#1e293b',
                padding: 'clamp(20px, 5vw, 30px)',
                borderRadius: '20px',
                maxWidth: 'min(400px, calc(100vw - 40px))',
                width: '100%',
                textAlign: 'center',
                position: 'relative',
                boxSizing: 'border-box',
            }}>
                <button
                    onClick={onClose}
                    style={{
                        position: 'absolute',
                        top: '10px',
                        right: '10px',
                        background: 'none',
                        border: 'none',
                        color: '#94a3b8',
                        fontSize: '24px',
                        cursor: 'pointer',
                    }}
                >
                    &times;
                </button>

                <h2 style={{ fontSize: '24px', marginBottom: '10px' }}>Unlock Full Access</h2>
                <p style={{ color: '#94a3b8', marginBottom: '30px' }}>
                    Get unlimited access to all characters and advanced features.
                </p>

                {errorV && (
                    <div style={{ color: '#ef4444', marginBottom: '15px' }}>
                        {errorV}
                    </div>
                )}

                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                    {packages.map((pack) => (
                        <button
                            key={pack.identifier}
                            onClick={() => handlePurchase(pack)}
                            disabled={loading}
                            style={{
                                width: '100%',
                                padding: '15px',
                                borderRadius: '12px',
                                border: 'none',
                                background: 'linear-gradient(135deg, #22c55e, #3b82f6)',
                                color: 'white',
                                fontSize: '16px',
                                fontWeight: 'bold',
                                cursor: loading ? 'not-allowed' : 'pointer',
                                opacity: loading ? 0.7 : 1,
                            }}
                        >
                            {loading ? 'Processing...' : `Subscribe ${pack.product.priceString} / ${pack.packageType === 'ANNUAL' ? 'Year' : 'Month'}`}
                        </button>
                    ))}
                    {packages.length === 0 && (
                        <div style={{ color: '#94a3b8', padding: '20px' }}>
                            Loading subscription options... (Ensure products are configured in RevenueCat)
                        </div>
                    )}
                </div>

                <button
                    onClick={handleRestore}
                    disabled={loading}
                    style={{
                        marginTop: '20px',
                        background: 'none',
                        border: 'none',
                        color: '#94a3b8',
                        fontSize: '14px',
                        textDecoration: 'underline',
                        cursor: loading ? 'not-allowed' : 'pointer',
                    }}
                >
                    Restore Purchases
                </button>

                <div style={{ marginTop: '30px', fontSize: '12px', color: '#64748b' }}>
                    <a href="#" style={{ color: '#64748b', marginRight: '10px' }}>Privacy Policy</a>
                    <a href="#" style={{ color: '#64748b' }}>Terms of Service</a>
                </div>
            </div>
        </div>
    );
};

export default Paywall;
